import { FC } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { useWishlist } from 'modules/shop/wishlist/useWishlist';
import { WishlistIconView } from './WishlistIconView';
import { IWishlistIcon } from './types';

export const WishlistIcon: FC<IWishlistIcon> = ({
  className,
  variantId,
  productName,
}) => {
  const { addToWishlist, wishlist, removeFromWishlist } = useWishlist();
  const { gtmData } = useSiteConfig();

  return (
    <WishlistIconView
      wishlist={wishlist}
      variantId={variantId}
      productName={productName}
      addToWishlist={addToWishlist}
      removeFromWishlist={removeFromWishlist}
      pageType={gtmData?.pageType}
      className={className}
    />
  );
};
